import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { MediaEntity } from '../entities';
import { MediaState } from '../states';

export const mediaAdapter: EntityAdapter<MediaEntity> = createEntityAdapter<MediaEntity>();

export const initialState: MediaState = mediaAdapter.getInitialState({
    loading: false,
    loaded: false,
    prevUrl: null,
    nextUrl: null,
    createdMediaId: 0

});